module.exports = __webpack_public_path__ + "static/media/Success.946c420b.jpg";